import { useEffect, useState } from "react";
import { getCookie, setCookie } from "../utils/cookies";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSections";
import CoursesSection from "../components/CoursesSection";
import WhyChooseUs from "../components/WhyChooseUs";
import ContactSection from "../components/ContactSections";
import StarPerformers from "../components/StarPerformers";
import CompetitionResults from "../components/CompetitionResults";
import EnquirySection from "../components/EnquirySection";
import Footer from "../components/Footer";
import WhatsappButton from "../components/WhatsappButton";
import EnrollModal from "../components/EnrollModal";
import Seo from "../components/Seo";
import { useSeo } from "../hooks/useSeo";
const ENROLLMETCOUNT = 8000
const Index = () => {
    const [enrollOpen, setEnrollOpen] = useState(false);
	const { data: seo } = useSeo("/");
    useEffect(() => {
        const seen = getCookie("seen_enroll");
        if (seen) return;

        const timer = setTimeout(() => {
            setEnrollOpen(true);
            setCookie("seen_enroll", "yes", 365);
        }, ENROLLMETCOUNT);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="min-h-screen bg-blue-50">
			 <Seo
                title={seo?.title || "Swar Natyam Dance Academy"}
                description={seo?.description}
                canonical={seo?.canonical}
                ogImage={seo?.ogImage}
                noindex={seo?.noindex}
                jsonLd={seo?.jsonLd}
            />
            <Navbar />
            <HeroSection onEnrollClick={() => setEnrollOpen(true)} />
            <CoursesSection />
            <WhyChooseUs />
            <StarPerformers />
            <CompetitionResults />
            <EnquirySection />
            <ContactSection />
            <Footer />
            <WhatsappButton />
            <EnrollModal open={enrollOpen} onClose={() => setEnrollOpen(false)} />
        </div>
    );
};

export default Index;